(function () {
  let timer = null;

  function getSelectedVariantId() {
    const urlVariant = new URL(window.location.href).searchParams.get("variant");
    if (urlVariant) {
      const v = parseInt(urlVariant, 10);
      if (Number.isFinite(v)) return v;
    }

    const idInput = document.querySelector('form[action^="/cart/add"] [name="id"]');
    if (!idInput) return null;

    const v = parseInt(idInput.value, 10);
    return Number.isFinite(v) ? v : null;
  }

  function getVariantInventoryData() {
    const script = document.querySelector(
      'script.js-variant-inventory-json[type="application/json"]'
    );
    if (!script) return null;

    try {
      const data = JSON.parse(script.textContent);
      return Array.isArray(data) ? data : null;
    } catch (e) {
      return null;
    }
  }

  function apply() {
    const wrap = document.querySelector(".js-inventory-status");
    if (!wrap) return;

    const threshold = parseInt(wrap.dataset.lowStockThreshold, 10);
    if (!Number.isFinite(threshold)) return;

    const selectedVariantId = getSelectedVariantId();
    const variantData = getVariantInventoryData();

    // If we can't determine, leave Spotlight default visible (don't break page)
    if (!selectedVariantId || !variantData) return;

    const v = variantData.find((x) => Number(x.id) === Number(selectedVariantId));
    if (!v) return;

    const qty = Number(v.qty);

    // Only show when 1..9
    const shouldShow = Number.isFinite(qty) && qty > 0 && qty < threshold;

    wrap.style.display = shouldShow ? "" : "none";
  }

  function scheduleApply() {
    // Debounce + run twice to catch async variant updates
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      apply();
      setTimeout(apply, 50);
    }, 0);
  }

  function init() {
    scheduleApply();

    // Variant option changes
    document.addEventListener("change", (e) => {
      if (e.target.closest('form[action^="/cart/add"]')) scheduleApply();
    });

    // URL ?variant= changes
    window.addEventListener("popstate", scheduleApply);

    // Some themes emit this custom event
    document.addEventListener("variant:change", scheduleApply);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();